import React from "react";

function AWSReportsCards({ reportCards }) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
      {reportCards.map((card, index) => (
        <div
          key={index}
          onClick={card.enabled ? card.action : undefined}
          className={`bg-white rounded-lg p-6 border transition-all duration-200 shadow-md group ${
            card.enabled
              ? "border-gray-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transform hover:-translate-y-1"
              : "border-gray-100 bg-gray-50 cursor-not-allowed"
          }`}
        >
          <div className="flex items-center mb-3">
            {card.icon.startsWith("/") ? (
              <img
                src={card.icon}
                alt={card.title}
                className={`${card.iconClassName || "w-8 h-8"} mr-3 object-contain`}
              />
            ) : (
              <span className="text-2xl mr-3">{card.icon}</span>
            )}
            <h3
              className={`text-lg font-semibold ${
                card.enabled
                  ? "text-gray-900 group-hover:text-orange-600"
                  : "text-gray-500"
              }`}
            >
              {card.title}
            </h3>
          </div>
          <p
            className={`mb-6 ${
              card.enabled ? "text-gray-600" : "text-gray-400"
            }`}
          >
            {card.description}
          </p>
          <div
            className={`flex items-center justify-end gap-2 text-sm font-medium ${
              card.enabled
                ? "text-orange-600 group-hover:text-orange-700"
                : "text-gray-400"
            }`}
          >
            <span>{card.enabled ? (card.actionText || "View Report") : "Coming Soon"}</span>
            {card.enabled && (
              <svg
                className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AWSReportsCards;
